import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import { Heading6 } from '@ui/Typography'

import { BackButton } from '@shared/components/BackButton'

import styles from './DocumentTemplate.module.scss'

interface CommandPageTemplateProps {
  title?: string | null
  goBack?(): void
}

export const DocumentTemplate: React.FunctionComponent<
  PropsWithChildren<CommandPageTemplateProps>
> = ({ children, title, goBack }) => {
  return (
    <div className={classNames(styles.wrapper)}>
      <div className={classNames(styles.header)}>
        {goBack && <BackButton onClick={goBack} />}
        <Heading6 medium>{title}</Heading6>
        <div className={styles.emptyBlock} />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
